import React, {useState, useEffect, Fragment} from 'react';
import localization from "../../../../assets/localization/localization";
import DivLayout from "../../../../components/sales/divLayout/divLayout";
import {STATUS} from "../../../../constants/statusConstant";
import moment from "moment/moment";
import {Link} from "react-router-dom";
import DocumentView from "../../../../components/sales/downloadDocView/documentView";
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import LedgerFilter from 'components/sales/ListFilters/LedgerFilter';

const ApprovalView = (
    {
        viewDetails = [],
        handleSubmit = () => {},
        disableSubmitButton = false
    }
) => {

    const [teamId, setTeamId] = useState();

    useEffect(() => {
        (async () => {
            let team =
                (await JSON.parse(localStorage.getItem('viewDetail'))) &&
                JSON.parse(localStorage.getItem('viewDetail'))[0]?.lead_type_id;

            if(team === undefined){
                team = (await JSON.parse(localStorage.getItem('viewDetail'))) &&
                    JSON.parse(localStorage.getItem('viewDetail'))[0]?.lead_type.id;
            }
            setTeamId(team);
        })();
    }, []);

    const [businessName, setBusinessName] = useState("");
    const [confirmBusinessName, setConfirmPassword] = useState("");
    const [businessNameError, setBusinessNameError] = useState("");

    const handleBusinessNameChange = (val) => {
        setBusinessName(val);
        validatePasswords(val, confirmBusinessName);
    };

    const handleConfirmBusinessNameChange = (val) => {
        setConfirmPassword(val);
        validatePasswords(businessName, val);
    };

    const validatePasswords = (pass, confirmPass) => {
        if (pass !== confirmPass) {
            setBusinessNameError("Business Name do not match.");
        } else {
            setBusinessNameError("");
        }
    };

    return (
        <>
            <Fragment>
                 <div className="panel_align">

                     <div className="panel-card card-details" width="100%">
                         <div className="panel-heading">{localization.leadDetails}</div>
                         <div className="panel-body">
                             <div className="details-listing detail_alignment">
                            <DivLayout
                                heading={localization.leadNumber}
                                data={
                                    viewDetails?.lead_data?.id
                                        ? viewDetails?.lead_data.id
                                        : localization.na
                                }
                            />
                            { viewDetails?.lead_data && viewDetails?.lead_data.site_no?
                                <DivLayout
                                    heading={localization.siteNumber}
                                    data={
                                        viewDetails?.lead_data?.site_no
                                            ? viewDetails?.lead_data.site_no
                                            : localization.na
                                    }
                                />
                                : null
                            }

                            {viewDetails?.lead_data && viewDetails?.lead_data.company_name ? (
                                <DivLayout
                                    heading={localization.clientName}
                                    data={
                                        viewDetails?.lead_data?.company_name
                                            ? viewDetails?.lead_data.company_name
                                            : localization.na
                                    }
                                />
                            ) : (
                                <DivLayout
                                    heading={localization.clientName}
                                    data={
                                        viewDetails?.lead_data?.client_name
                                            ? viewDetails?.lead_data.client_name
                                            : localization.na
                                    }
                                />
                            )}
                            {viewDetails?.lead_data && viewDetails?.lead_data.lead_type != "Apartment" ? (
                                <DivLayout
                                    heading={localization.building_name}
                                    data={
                                        viewDetails?.lead_data?.building_name
                                            ? viewDetails?.lead_data.building_name
                                            : localization.na
                                    }
                                />
                            ) : ''
                            }
                            <DivLayout
                                heading={localization.createdOn}
                                data={
                                    viewDetails?.lead_data?.created_at
                                        ? viewDetails?.lead_data.created_at
                                        : localization.na
                                }
                            />
                            <DivLayout
                                heading={localization.siteType}
                                data={
                                    viewDetails?.lead_data?.location_type
                                        ? viewDetails?.lead_data.location_type
                                        : localization.na
                                }
                            />

                            {teamId === STATUS.SUPPLY ? (
                                <DivLayout
                                    heading={localization.siteType}
                                    data={
                                        viewDetails?.lead_data?.site_type
                                            ? viewDetails?.lead_data.site_type
                                            : localization.na
                                    }
                                />
                            ) : (
                                <Fragment>
                                    <DivLayout
                                        heading={localization.LeadSource}
                                        data={
                                            viewDetails?.lead_data?.lead_source
                                                ? viewDetails?.lead_data.lead_source
                                                : localization.na
                                        }
                                    />
                                    {viewDetails?.lead_data?.alternateChannle && (
                                        <DivLayout
                                            heading={'Alternate Channel'}
                                            data={
                                                viewDetails?.lead_data?.alternateChannle
                                                    ? viewDetails?.lead_data.alternateChannle
                                                    : localization.naLeadSource
                                            }
                                        />
                                    )}
                                    {viewDetails?.lead_data?.mainSource && (
                                        <DivLayout
                                            heading={localization.mainSource}
                                            data={
                                                viewDetails?.lead_data?.mainSource
                                                    ? viewDetails?.lead_data.mainSource
                                                    : localization.naLeadSource
                                            }
                                        />
                                    )}
                                    {viewDetails?.lead_data?.other_lead_source && (
                                        <DivLayout
                                            heading={'Other ' + localization.LeadSource}
                                            data={
                                                viewDetails?.lead_data?.other_lead_source
                                                    ? viewDetails?.lead_data.other_lead_source
                                                    : localization.naLeadSource
                                            }
                                        />
                                    )}
                                </Fragment>
                            )}
                            <DivLayout
                                heading={localization.occupancy}
                                data={
                                    viewDetails?.lead_data?.occupancy
                                        ? viewDetails?.lead_data.occupancy
                                        : localization.na
                                }
                            />
                            <DivLayout
                                heading={localization.existingSolution}
                                data={
                                    viewDetails?.lead_data?.existing_solution
                                        ? viewDetails?.lead_data.existing_solution
                                        : localization.na
                                }
                            />
                            <DivLayout
                                heading={localization.marqueeSite}
                                data={
                                    viewDetails?.lead_data?.is_marquee_site
                                        ? viewDetails?.lead_data.is_marquee_site
                                        : localization.na
                                }
                            />
                            <DivLayout
                                heading={localization.salesTeamMember}
                                data={
                                    viewDetails?.lead_data?.assigned_to
                                        ? viewDetails?.lead_data.assigned_to
                                        : localization.na
                                }
                            />
                            <DivLayout
                                heading={localization.salesMemberDesignation}
                                data={
                                    viewDetails?.lead_data?.assigned_to_designation
                                        ? viewDetails?.lead_data.assigned_to_designation
                                        : localization.na
                                }
                            />
                            <DivLayout
                                heading={localization.status}
                                status
                                data={
                                    viewDetails?.lead_data?.status
                                        ? viewDetails?.lead_data.status
                                        : localization.na
                                }
                            />
                            {viewDetails?.lead_data?.status === 'Rejected' && (
                                <DivLayout
                                    heading={localization.remarks}
                                    status
                                    data={
                                        viewDetails?.lead_data?.reject_remarks
                                            ? viewDetails?.lead_data.reject_remarks
                                            : localization.na
                                    }
                                />
                            )}

                            <DivLayout
                                heading={localization.contactDate}
                                status
                                data={
                                    viewDetails?.lead_data?.contact_date
                                        ? moment(
                                            viewDetails?.lead_data.contact_date,
                                            'DD-MM-YYYY'
                                        ).format('DD-MM-YYYY')
                                        : localization.na
                                }
                            />
                        </div>
                    </div>
                </div>

                {/* </div> */}
                {viewDetails?.lead_data?.tp_poc_details && (
                    <>
                        <div className="panel-card">
                            <div className="panel-heading">{localization.leadDetails}</div>
                            <div className="panel-body">
                                <div className="details-listing detail_alignment">
                                    {teamId === STATUS.CORPORATE ||
                                    teamId === STATUS.APARTMENT ? (
                                        <Fragment>
                                            <DivLayout
                                                heading={localization.pocType}
                                                data={
                                                    viewDetails?.lead_data && viewDetails?.lead_data?.other_poc_sites
                                                        ? viewDetails?.lead_data?.other_poc_sitesgit 
                                                        : localization.na
                                                }
                                            />
                                        </Fragment>
                                    ) : null}
                                    <DivLayout
                                        heading={localization.fmcName}
                                        data={
                                            viewDetails?.lead_data?.tp_poc_details &&
                                            viewDetails?.lead_data.tp_poc_details?.fmc_name
                                                ? viewDetails?.lead_data.tp_poc_details?.fmc_name
                                                : localization.na
                                        }
                                    />
                                    <DivLayout
                                        heading={localization.POCName}
                                        data={
                                            viewDetails?.lead_data?.tp_poc_details &&
                                            viewDetails?.lead_data?.tp_poc_details?.name
                                                ? viewDetails?.lead_data?.tp_poc_details?.name
                                                : localization.na
                                        }
                                    />
                                    <DivLayout
                                        heading={localization.designation}
                                        data={
                                            viewDetails?.lead_data?.tp_poc_details &&
                                            viewDetails?.lead_data?.tp_poc_details?.designation
                                                ? viewDetails?.lead_data?.tp_poc_details.designation
                                                : localization.na
                                        }
                                    />
                                    <DivLayout
                                        heading={localization.phoneNumber}
                                        data={
                                            viewDetails?.lead_data?.tp_poc_details &&
                                            viewDetails?.lead_data?.tp_poc_details?.phone
                                                ? viewDetails?.lead_data?.tp_poc_details.phone
                                                : localization.na
                                        }
                                    />
                                    <DivLayout
                                        heading={localization.emailAddress}
                                        data={
                                            viewDetails?.lead_data?.tp_poc_details &&
                                            viewDetails?.lead_data?.tp_poc_details?.email
                                                ? viewDetails?.lead_data?.tp_poc_details.email
                                                : localization.na
                                        }
                                    />

                                    <DivLayout
                                        heading={localization.secondContact}
                                        data={
                                            viewDetails?.lead_data?.tp_poc_details &&
                                            viewDetails?.lead_data?.tp_poc_details?.contact_no
                                                ? viewDetails?.lead_data?.tp_poc_details.contact_no
                                                : localization.na
                                        }
                                    />
                                    <DivLayout
                                        heading={localization.mailCamp}
                                        data={
                                            viewDetails?.lead_data?.tp_poc_details &&
                                            viewDetails?.lead_data?.tp_poc_details?.mail_campaign
                                                ? viewDetails?.lead_data?.tp_poc_details.mail_campaign
                                                : localization.na
                                        }
                                    />

                                    {/* {teamId === STATUS.CORPORATE || teamId === STATUS.APARTMENT ? (
                  <DivLayout
                    heading={localization.secondaryContact}
                    data={
                      viewDetails?.viewDetails?.lead_data.tp_poc_viewDetails?.viewDetails?.secondary_contact
                        ? viewDetails?.viewDetails.lead_data.tp_poc_viewDetails?.viewDetails.secondary_contact
                        : localization.na
                    }
                  />
                ) : null} */}
                                </div>
                            </div>
                        </div>
                        <div className="panel-card">
                            <div className="panel-heading">
                                {localization.locationDetail}
                            </div>
                            <div className="panel-body">
                                <div className="details-listing detail_alignment">
                                    <DivLayout
                                        heading={localization.city}
                                        data={
                                            viewDetails?.lead_data?.city
                                                ? viewDetails?.lead_data.city
                                                : localization.na
                                        }
                                    />
                                    <DivLayout
                                        heading={localization.zone}
                                        data={
                                            viewDetails?.lead_data?.zone
                                                ? viewDetails?.lead_data.zone
                                                : localization.na
                                        }
                                    />
                                    <DivLayout
                                        heading={localization.area}
                                        data={
                                            viewDetails?.lead_data?.area
                                                ? viewDetails?.lead_data.area
                                                : localization.na
                                        }
                                    />
                                    <div className="details-list">
                                        <strong className="data-title">
                                            {localization.address}
                                        </strong>
                                        <span className="data-details">
                        {viewDetails?.lead_data?.address_line_one
                            ? viewDetails?.lead_data.address_line_one
                            : localization.na}{' '}
                                            {viewDetails?.lead_data?.address_line_two}
                      </span>
                                    </div>
                                    <DivLayout
                                        heading={localization.current_location}
                                        data={
                                            viewDetails?.lead_data?.current_location
                                                ? viewDetails?.lead_data.current_location
                                                : localization.na
                                        }
                                    />
                                    <DivLayout
                                        heading={localization.lat}
                                        data={
                                            viewDetails?.lead_data?.latitude
                                                ? viewDetails?.lead_data.latitude
                                                : localization.na
                                        }
                                    />
                                    <DivLayout
                                        heading={localization.lng}
                                        data={
                                            viewDetails?.lead_data?.longitude
                                                ? viewDetails?.lead_data.longitude
                                                : localization.na
                                        }
                                    />
                                    <DivLayout
                                        heading={localization.locationType}
                                        data={
                                            viewDetails?.lead_data?.location_type
                                                ? viewDetails?.lead_data.location_type
                                                : localization.na
                                        }
                                    />
                                    <DivLayout
                                        heading={localization.pinCode}
                                        data={
                                            viewDetails?.lead_data?.geo_pincode
                                                ? viewDetails?.lead_data.geo_pincode
                                                : localization.na
                                        }
                                    />
                                    <DivLayout
                                        heading={localization.geoState}
                                        data={
                                            viewDetails?.lead_data?.geo_state
                                                ? viewDetails?.lead_data.geo_state
                                                : localization.na
                                        }
                                    />
                                    <DivLayout
                                        heading={localization.geoCity}
                                        data={
                                            viewDetails?.lead_data?.geo_city
                                                ? viewDetails?.lead_data.geo_city
                                                : localization.na
                                        }
                                    />
                                </div>
                            </div>
                        </div>

                        {viewDetails?.lead_data?.lead_sub_type !== 10 &&
                            <div className="panel-card">
                                <div className="panel-heading">
                                    {localization.categoryDetails}
                                </div>
                                <div className="panel-body">
                                    {teamId === STATUS.APARTMENT && (
                                        <Fragment>
                                            <div className="details-listing">
                                                <DivLayout
                                                    heading={localization.LeadCategory}
                                                    data={
                                                        viewDetails?.lead_data?.lead_category
                                                            ? viewDetails?.lead_data.lead_category
                                                            : localization.na
                                                    }
                                                />


                                                <DivLayout
                                                    heading={localization.societyType}
                                                    data={
                                                        viewDetails?.lead_data?.society_type
                                                            ? viewDetails?.lead_data.society_type
                                                            : localization.na
                                                    }
                                                />

                                                <DivLayout
                                                    heading={localization.vms}
                                                    data={
                                                        viewDetails?.lead_data?.vms_type
                                                            ? viewDetails?.lead_data.vms_type
                                                            : localization.na
                                                    }
                                                />
                                                <DivLayout
                                                    heading={localization.noOfFlats}
                                                    data={
                                                        viewDetails?.lead_data?.no_of_flats
                                                            ? viewDetails?.lead_data.no_of_flats
                                                            : localization.na
                                                    }
                                                />
                                                <DivLayout
                                                    heading={localization.existingsetup}
                                                    data={
                                                        viewDetails?.lead_data?.existing_setup
                                                            ? viewDetails?.lead_data.existing_setup
                                                            : localization.na
                                                    }
                                                />
                                                <DivLayout
                                                    heading={localization.occupancy}
                                                    data={
                                                        viewDetails?.lead_data?.occupancy
                                                            ?viewDetails?.lead_data.occupancy
                                                            : localization.na
                                                    }
                                                />
                                                <DivLayout
                                                    heading={localization.securityAgency}
                                                    data={
                                                        viewDetails?.lead_data?.security_agency
                                                            ? viewDetails?.lead_data.security_agency
                                                            : localization.na
                                                    }
                                                />
                                                <DivLayout
                                                    heading={localization.AverageMaintenance}
                                                    data={
                                                        viewDetails?.lead_data?.maintainance_charges
                                                            ?viewDetails?.lead_data.maintainance_charges
                                                            : localization.na
                                                    }
                                                />
                                                <DivLayout
                                                    heading={localization.disputeLevel}
                                                    data={
                                                        viewDetails?.lead_data?.dispute_level
                                                            ?viewDetails?.lead_data.dispute_level
                                                            : localization.na
                                                    }
                                                />
                                                <DivLayout
                                                    heading={localization.societyUpkeeping}
                                                    data={
                                                        viewDetails?.lead_data?.society_upkeeping
                                                            ?viewDetails?.lead_data.society_upkeeping
                                                            : localization.na
                                                    }
                                                />
                                                <DivLayout
                                                    heading={localization.amenities}
                                                    data={
                                                        viewDetails?.lead_data?.amenities
                                                            ?viewDetails?.lead_data.amenities
                                                            : localization.na
                                                    }
                                                />
                                                <DivLayout
                                                    heading={localization.managedBy}
                                                    data={
                                                        viewDetails?.lead_data?.managed_by
                                                            ?viewDetails?.lead_data.managed_by
                                                            : localization.na
                                                    }
                                                />
                                            </div>
                                        </Fragment>
                                    )}

                                    {teamId === STATUS.CORPORATE && (
                                        <Fragment>
                                            <div className="details-listing">
                                                <DivLayout
                                                    heading={localization.LeadCategory}
                                                    data={
                                                        viewDetails?.lead_data?.lead_category
                                                            ? viewDetails?.lead_data.lead_category
                                                            : localization.na
                                                    }
                                                />
                                                {viewDetails?.lead_data?.lead_category &&
                                                    viewDetails?.lead_data?.lead_category_id === 2 && (
                                                        <DivLayout
                                                            heading={localization.supplyNamePost}
                                                            data={
                                                                viewDetails?.lead_data?.supply_name
                                                                    ? viewDetails?.lead_data.supply_name
                                                                    : localization.na
                                                            }
                                                        />
                                                    )}
                                                {(viewDetails?.lead_data?.lead_category_id &&
                                                    viewDetails?.lead_data?.lead_category_id === 1) ||
                                                (viewDetails?.lead_data?.lead_category_id &&
                                                    viewDetails?.lead_data?.lead_category_id === 3) ? (
                                                    <DivLayout
                                                        heading={localization.noOfgates}
                                                        data={
                                                            viewDetails?.lead_data?.no_of_gates
                                                                ? viewDetails?.lead_data.no_of_gates
                                                                : localization.na
                                                        }
                                                    />
                                                ) : null}

                                                {(viewDetails?.lead_data?.lead_category_id &&
                                                    viewDetails?.lead_data?.lead_category_id === 2) ||
                                                (viewDetails?.lead_data?.lead_category_id &&
                                                    viewDetails?.lead_data?.lead_category_id === 3) ? (
                                                    <DivLayout
                                                        heading={localization.noOfSlots}
                                                        data={
                                                            viewDetails?.lead_data?.no_of_slots
                                                                ? viewDetails?.lead_data.no_of_slots
                                                                : localization.na
                                                        }
                                                    />
                                                ) : null}
                                                {viewDetails?.lead_data?.lead_category_id &&
                                                    viewDetails?.lead_data?.lead_category_id === 2 && (
                                                        <>
                                                            <DivLayout
                                                                heading={localization.reservedSlots}
                                                                data={
                                                                    viewDetails?.lead_data?.reserved
                                                                        ? viewDetails?.lead_data.reserved
                                                                        : localization.na
                                                                }
                                                            />
                                                            <DivLayout
                                                                heading={localization.FCFSSlots}
                                                                data={
                                                                    viewDetails?.lead_data?.fcfs
                                                                        ? viewDetails?.lead_data.fcfs
                                                                        : localization.na
                                                                }
                                                            />
                                                        </>
                                                    )}
                                                {viewDetails?.lead_data?.lead_category_id &&
                                                    viewDetails?.lead_data?.lead_category_id === 8 && (
                                                        <>
                                                            <DivLayout
                                                                heading={localization.strategicPartner}
                                                                data={
                                                                    viewDetails?.lead_data?.partner
                                                                        ? viewDetails?.lead_data.partner
                                                                        : localization.na
                                                                }
                                                            />
                                                        </>
                                                    )}
                                                <DivLayout
                                                    heading={localization.noOfSlots}
                                                    data={
                                                        viewDetails?.lead_data?.no_of_slots
                                                            ? viewDetails?.lead_data.no_of_slots
                                                            : localization.na
                                                    }
                                                />
                                                <DivLayout
                                                    heading={localization.noOfEVChargers}
                                                    data={
                                                        viewDetails?.lead_data?.no_of_ev_chargers
                                                            ? viewDetails?.lead_data.no_of_ev_chargers
                                                            : localization.na
                                                    }
                                                />
                                                <DivLayout
                                                    heading={localization.vms}
                                                    data={
                                                        viewDetails?.lead_data?.vms_type
                                                            ? viewDetails?.lead_data.vms_type
                                                            : localization.na
                                                    }
                                                />
                                            </div>

                                        </Fragment>
                                    )}

                                    {teamId === STATUS.SUPPLY && (
                                        <Fragment>
                                            <div className="details-listing">
                                                <DivLayout
                                                    heading={localization.LeadCategory}
                                                    data={
                                                        viewDetails?.lead_data?.lead_category
                                                            ? viewDetails?.lead_data.lead_category
                                                            : localization.na
                                                    }
                                                />
                                                <DivLayout
                                                    heading={localization.reqDes}
                                                    data={
                                                        viewDetails?.lead_data?.requirements_description
                                                            ? viewDetails?.lead_data.requirements_description
                                                            : localization.na
                                                    }
                                                />
                                            </div>
                                        </Fragment>
                                    )}

                                    {teamId === STATUS.B2BALLIANCE && (
                                        <Fragment>
                                            <div className="details-listing">
                                                <DivLayout
                                                    heading={localization.remarks}
                                                    data={
                                                        viewDetails?.lead_data?.remarks
                                                            ? viewDetails?.lead_data.remarks
                                                            : localization.na
                                                    }
                                                />
                                                <DivLayout
                                                    heading={localization.categoryAlliances}
                                                    data={
                                                        viewDetails?.lead_data?.lead_category
                                                            ? viewDetails?.lead_data.lead_category
                                                            : localization.na
                                                    }
                                                />
                                            </div>
                                        </Fragment>
                                    )}
                                </div>
                            </div>
                        }

                        {viewDetails?.lead_data?.gate_details && (
                            <div className="panel-card">
                                <div className="panel-heading">
                                    {localization.gateType}
                                </div>
                                <div className="panel-body">

                                    <div className="details-listing">
                                        {viewDetails?.lead_data?.gate_details && viewDetails?.lead_data?.gate_details.map((item, index) => {
                                            return (
                                                <div className="row">
                                                    <div className="col-6">
                                                        <DivLayout
                                                            heading={localization.gateType+' '+(Number(index)+1)}
                                                            data={
                                                                item?.gate_type
                                                                    ? item.gate_type
                                                                    : localization.na
                                                            }
                                                        />
                                                    </div>
                                                    <div className="col-6">
                                                        <DivLayout
                                                            heading={localization.quantity}
                                                            data={
                                                                item?.gatequantity
                                                                    ? item.gatequantity
                                                                    : localization.na
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            );
                                        })}


                                    </div>
                                </div>
                            </div>
                        )}

                        {viewDetails?.lead_data?.ucd_details && (
                            <>
                                <div className="panel-card">
                                    <div className="panel-heading">
                                        Dealer Details
                                    </div>
                                    <div className="panel-body">

                                        <div className="details-listing">
                                            {viewDetails?.lead_data?.ucd_details &&
                                                <>
                                                    <div className="row">
                                                        <div className="col-6">
                                                            <DivLayout
                                                                heading={"Business Name"}
                                                                data={
                                                                    viewDetails?.lead_data?.ucd_details?.business_name
                                                                        ? viewDetails?.lead_data?.ucd_details?.business_name
                                                                        : localization.na
                                                                }
                                                            />
                                                        </div>
                                                        <div className="col-6">
                                                            <DivLayout
                                                                heading={"Owner Name"}
                                                                data={
                                                                    viewDetails?.lead_data?.ucd_details?.owner_name
                                                                        ? viewDetails?.lead_data?.ucd_details?.owner_name
                                                                        : localization.na
                                                                }
                                                            />
                                                        </div>
                                                        <div className="col-6">
                                                            <DivLayout
                                                                heading={"Channel Type"}
                                                                data={
                                                                    viewDetails?.lead_data?.ucd_details?.channel_type
                                                                        ? viewDetails?.lead_data?.ucd_details?.channel_type
                                                                        : localization.na
                                                                }
                                                            />
                                                        </div>
                                                        <div className="col-6">
                                                            <DivLayout
                                                                heading={"Organization Type"}
                                                                data={
                                                                    viewDetails?.lead_data?.ucd_details?.organization_type
                                                                        ? viewDetails?.lead_data?.ucd_details?.organization_type
                                                                        : localization.na
                                                                }
                                                            />
                                                        </div>
                                                        <div className="col-6">
                                                            <DivLayout
                                                                heading={"GST No."}
                                                                data={
                                                                    viewDetails?.lead_data?.ucd_details?.dealer_gst_no
                                                                        ? viewDetails?.lead_data?.ucd_details?.dealer_gst_no
                                                                        : localization.na
                                                                }
                                                            />
                                                        </div>
                                                        <div className="col-6">
                                                            <DivLayout
                                                                heading={"PAN No."}
                                                                data={
                                                                    viewDetails?.lead_data?.ucd_details?.dealer_pan_no
                                                                        ? viewDetails?.lead_data?.ucd_details?.dealer_pan_no
                                                                        : localization.na
                                                                }
                                                            />
                                                        </div>
                                                        <div className="col-6">
                                                            <DivLayout
                                                                heading={"Eamil"}
                                                                data={
                                                                    viewDetails?.lead_data?.ucd_details?.registration_email
                                                                        ? viewDetails?.lead_data?.ucd_details?.registration_email
                                                                        : localization.na
                                                                }
                                                            />
                                                        </div>
                                                        <div className="col-6">
                                                            <DivLayout
                                                                heading={"Registration Phone No."}
                                                                data={
                                                                    viewDetails?.lead_data?.ucd_details?.registration_mobile_no
                                                                        ? viewDetails?.lead_data?.ucd_details?.registration_mobile_no
                                                                        : localization.na
                                                                }
                                                            />
                                                        </div>
                                                        <div className="col-6">
                                                            <DivLayout
                                                                heading={"Aadhar No."}
                                                                data={
                                                                    viewDetails?.lead_data?.ucd_details?.aadhar_no
                                                                        ? viewDetails?.lead_data?.ucd_details?.aadhar_no
                                                                        : localization.na
                                                                }
                                                            />
                                                        </div>
                                                        <div className="col-6">
                                                            <DivLayout
                                                                heading={"MSME Certificate"}
                                                                data={
                                                                    viewDetails?.lead_data?.ucd_details?.msme_certificate
                                                                        ? viewDetails?.lead_data?.ucd_details?.msme_certificate
                                                                        : localization.na
                                                                }
                                                            />
                                                        </div>

                                                        <div className="col-6">
                                                            <DivLayout
                                                                heading={"MSME No"}
                                                                data={
                                                                    viewDetails?.lead_data?.ucd_details?.msme_no
                                                                        ? viewDetails?.lead_data?.ucd_details?.msme_no
                                                                        : localization.na
                                                                }
                                                            />
                                                        </div>
                                                        <div className="col-6">
                                                            <DivLayout
                                                                heading={"Bank Name"}
                                                                data={
                                                                    viewDetails?.lead_data?.ucd_details?.bank_name
                                                                        ? viewDetails?.lead_data?.ucd_details?.bank_name
                                                                        : localization.na
                                                                }
                                                            />
                                                        </div>
                                                        <div className="col-6">
                                                            <DivLayout
                                                                heading={"Account No."}
                                                                data={
                                                                    viewDetails?.lead_data?.ucd_details?.account_no
                                                                        ? viewDetails?.lead_data?.ucd_details?.account_no
                                                                        : localization.na
                                                                }
                                                            />
                                                        </div>
                                                        <div className="col-6">
                                                            <DivLayout
                                                                heading={"IFSC Code"}
                                                                data={
                                                                    viewDetails?.lead_data?.ucd_details?.ifsc_code
                                                                        ? viewDetails?.lead_data?.ucd_details?.ifsc_code
                                                                        : localization.na
                                                                }
                                                            />
                                                        </div>
                                                        <div className="col-6">
                                                            <DivLayout
                                                                heading={"Account Type"}
                                                                data={
                                                                    viewDetails?.lead_data?.ucd_details?.account_type
                                                                        ? viewDetails?.lead_data?.ucd_details?.account_type
                                                                        : localization.na
                                                                }
                                                            />
                                                        </div>
                                                        <div className="col-6">
                                                            <DivLayout
                                                                heading={"Branch Name"}
                                                                data={
                                                                    viewDetails?.lead_data?.ucd_details?.branch_name
                                                                        ? viewDetails?.lead_data?.ucd_details?.branch_name
                                                                        : localization.na
                                                                }
                                                            />
                                                        </div>
                                                        {viewDetails?.lead_data?.ucd_details?.upload_cancelled_cheque &&
                                                            <div className="col-6">
                                                                <DocumentView
                                                                    attachment={viewDetails?.lead_data?.ucd_details?.upload_cancelled_cheque}
                                                                    title={"Cancelled Cheque"}
                                                                />
                                                            </div>
                                                        }

                                                        {viewDetails?.lead_data?.ucd_details?.gst_certificate_photo &&
                                                            <div className="col-6">
                                                                <DocumentView
                                                                    attachment={viewDetails?.lead_data?.ucd_details?.gst_certificate_photo}
                                                                    title={"GST Certificate"}
                                                                />
                                                            </div>
                                                        }


                                                        {viewDetails?.lead_data?.ucd_details?.selfie_with_dsa &&
                                                            viewDetails?.lead_data?.ucd_details?.selfie_with_dsa.map ((val, i) => {
                                                                return (
                                                                    <>
                                                                        <div className="col-6">
                                                                            <DocumentView
                                                                                attachment={val}
                                                                                title={`Selfie with dsa ${i+1} `}
                                                                            />
                                                                        </div>
                                                                    </>
                                                                )
                                                            })

                                                        }
                                                        {viewDetails?.lead_data?.ucd_details?.msme_declaration_photo &&
                                                            <div className="col-6">
                                                            <DocumentView
                                                                    attachment={viewDetails?.lead_data?.ucd_details?.msme_declaration_photo}
                                                                    title={"MSME Declaration"}
                                                                />
                                                            </div>
                                                        }

                                                        {viewDetails?.lead_data?.ucd_details?.msme_certificate_photo &&
                                                            <div className="col-6">
                                                                <DocumentView
                                                                    attachment={viewDetails?.lead_data?.ucd_details?.msme_certificate_photo}
                                                                    title={"MSME Certificate"}
                                                                />
                                                            </div>
                                                        }

                                                    </div>
                                                </>
                                            }


                                        </div>
                                    </div>
                                </div>
                                {viewDetails?.lead_data?.ucd_details?.office_location &&
                                    <>
                                    <div className="panel-card">
                                        <div className="panel-heading">
                                            Office Location
                                        </div>
                                        <div className="panel-body">

                                            <div className="details-listing">
                                                <div className="row">
                                                    <DivLayout
                                                        heading={"City"}
                                                        data={
                                                            viewDetails?.lead_data?.ucd_details?.city?.city_name
                                                                ? viewDetails?.lead_data?.ucd_details?.city?.city_name
                                                                : localization.na
                                                        }
                                                    />
                                                    <DivLayout
                                                        heading={"Zone"}
                                                        data={
                                                            viewDetails?.lead_data?.ucd_details?.zone?.zone_name
                                                                ? viewDetails?.lead_data?.ucd_details?.zone?.zone_name
                                                                : localization.na
                                                        }
                                                    />
                                                    <DivLayout
                                                        heading={"Area/Sector"}
                                                        data={
                                                            viewDetails?.lead_data?.ucd_details?.area?.area_name
                                                                ? viewDetails?.lead_data?.ucd_details?.area?.area_name
                                                                : localization.na
                                                        }
                                                    />

                                                    <DivLayout
                                                        heading={"Address"}
                                                        data={
                                                            viewDetails?.lead_data?.ucd_details?.office_location
                                                                ? viewDetails?.lead_data?.ucd_details?.office_location
                                                                : localization.na
                                                        }
                                                    />
                                                    <DivLayout
                                                        heading={"Geo City"}
                                                        data={
                                                            viewDetails?.lead_data?.ucd_details?.geo_city?.city_name
                                                                ? viewDetails?.lead_data?.ucd_details?.geo_city?.city_name
                                                                : localization.na
                                                        }
                                                    />
                                                    <DivLayout
                                                        heading={"Geo State"}
                                                        data={
                                                            viewDetails?.lead_data?.ucd_details?.geo_state?.state_name
                                                                ? viewDetails?.lead_data?.ucd_details?.geo_state?.state_name
                                                                : localization.na
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </>
                                }
                                <div className="panel-card">
                                    <div className="panel-heading">
                                        Dealer Images
                                    </div>
                                    <div className="panel-body">

                                        <div className="details-listing">
                                            <div className="row">
                                            {viewDetails?.lead_data?.ucd_details?.dealer_images && viewDetails?.lead_data?.ucd_details?.dealer_images.map((val, i) => {
                                                return (
                                                    <div className="col-6">
                                                        <DocumentView
                                                            attachment={val}
                                                            title={""}
                                                        />
                                                    </div>
                                                )
                                            })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>

                        )}
                    </>
                )}

                 </div>
                 
                    <hr />
                    
                    <div className='row'>
                        <div className='col-md-12 col-sm-12' style={{ textAlign: "Left", marginBottom: "10px"}}>
                        <strong>{`Business Name : ${viewDetails?.lead_data?.client_name ? viewDetails?.lead_data.client_name : localization.na}`}</strong><br /><small style={{color: "red"}}>{`(Above name as per submitted form - please enter the correct project name as this would be the display name of the society on the B2C app)`}</small>
                        </div>
                        <div className="col-md-6 col-sm-12">
                            <ConstantInput
                                label={localization.businessName}
                                type="password"
                                required
                                isStarRequired={true}
                                value={businessName}
                                handleChange={handleBusinessNameChange}
                                autoComplete="new-password"
                                onPaste={(e) => e.preventDefault()}
                                onCopy={(e) => e.preventDefault()}
                            />
                        </div>
                        <div className="col-md-6 col-sm-12">
                            <ConstantInput
                                label={localization.confirmBusinessName}
                                type="text"
                                required
                                isStarRequired={true}
                                handleChange={handleConfirmBusinessNameChange}
                                value={confirmBusinessName}
                                onPaste={(e) => e.preventDefault()}
                                onCopy={(e) => e.preventDefault()}
                            />
                        </div>
                        <div className="col-md-12 col-sm-12" style={{ textAlign: "Left"}}>
                            {businessNameError && <div style={{ color: "red" }}>{businessNameError}</div>}
                        </div>
                        
                    </div>

                    <div style={{top: "1rem" }}>
                        <button
                            data-toggle="modal"
                            disabled={disableSubmitButton || businessNameError || !businessName || !confirmBusinessName}
                            data-target="#accept"
                            className="btn btn-primary"
                            onClick={() => handleSubmit("accept",businessName)}
                        >
                            Approve
                        </button>
                    </div>

            </Fragment>
        </>
    )
}

export default ApprovalView